const klevuselectors = {
  buttonOpen: '.js-button-open',
  slideout: 'modal-dialog',
  SELECT_CLASS: '.js-selector',
  SELECT_HEADER_CLASS: '.js-selector-header',
  OPTION_CLASS: '.js-selector-option',
  DROPDOWN_EXPAND_CLASS: 'is-expand'
}

class ModalDialog extends HTMLElement {
  constructor() {
    super()

    this.closeBtn = this.querySelectorAll('.js-close-modal')
    this.contentEl = this.querySelector('.js-content-modal')
    this.attachEvents()

    if (this.hasAttribute('open')) {
      this.show()
    } else {
      this.hide()
    }
  }

  attachEvents() {
    this.closeBtn.forEach((btn) =>
      btn.addEventListener('click', () => {
        this.hide()
      })
    )

    this.addEventListener('click', () => {
      this.hide()
    })

      
    this.contentEl?.addEventListener('click', (e) => {
      e.stopPropagation()
    })

    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
  }

  show() {
    /** Hide all opened modal before open new modal */
    const allModals = document.querySelectorAll('modal-dialog.modal-dialog-opened')
    allModals.forEach((modal) => modal.hide())

    this.setAttribute('open', '');
    this.classList.add('modal-dialog-opened')
  }

  hide() {
    this.removeAttribute('open')
    this.classList.remove('modal-dialog-opened')
    window.bodyScrollLock.clearAllBodyScrollLocks()
  }
}

if (!customElements.get('modal-dialog')) {
  customElements.define('modal-dialog', ModalDialog)
}

class Accordions extends HTMLElement {
  constructor() {
    super()

    const ACCORDION_ACTIVE_CLASS = 'accordion__item--active'
    const ACCORDION_CONTENT_OPEN_CLASS = 'is-open'
    const ACCORDION_FOCUS_CLASS = 'is-focus'
    const ACCORDION_CONTENT_SELECTOR = '.js-content'
    const ACCORDION_BUTTON_SELECTOR = '.js-btn'
    const ACCORDION_ITEM_SELECTOR = '.js-item'

    const close = (item) => {
      item.classList.remove(ACCORDION_ACTIVE_CLASS)
      const content = item.querySelector(ACCORDION_CONTENT_SELECTOR)
      const btn = item.querySelector(ACCORDION_BUTTON_SELECTOR)
      if (btn && content) {
        btn.classList.remove(ACCORDION_FOCUS_CLASS)
        content.style.maxHeight = '0px'
        content.classList.remove(ACCORDION_CONTENT_OPEN_CLASS)
        btn.setAttribute('aria-expanded', 'false')
        item.removeAttribute('open')
      }
    }

    const open = (item) => {
      const content = item.querySelector(ACCORDION_CONTENT_SELECTOR)
      const button = item.querySelector(ACCORDION_BUTTON_SELECTOR)
      item.classList.add(ACCORDION_ACTIVE_CLASS)
      content.style.maxHeight = content.children[0].scrollHeight + 'px'
      content.classList.add(ACCORDION_CONTENT_OPEN_CLASS)
      button.setAttribute('aria-expanded', 'true')
      item.setAttribute('open', true)
    }

    const toggleDescription = (item) => {
      if (item && !item.hasAttribute('open')) {
        open(item)
      } else {
        close(item)
      }
    }

    const list = this.querySelectorAll(ACCORDION_ITEM_SELECTOR)
    if (list.length) {
      list.forEach((item) => {
        const button = item.querySelector(ACCORDION_BUTTON_SELECTOR)
        setTimeout(() => {
          open(item)
        }, 300)
        if (button) {
          button.onclick = function () {
            toggleDescription(item)
          }
        }
      })
    }
  }
}

if (!customElements.get('accordion-list')) {
  customElements.define('accordion-list', Accordions)
}

class KlevuSort extends HTMLElement {
  constructor() {
    super()

    this.selectEl = this.querySelector(klevuselectors.SELECT_CLASS)
    this.selectHeaderEl = this.querySelector(klevuselectors.SELECT_HEADER_CLASS)
    this.optionEl = this.querySelector(klevuselectors.OPTION_CLASS)

    this.handleExpand()
    this.handleClickOutside()
  }

  handleExpand () {
    this.selectHeaderEl.addEventListener('click', () => {
      this.selectEl.classList.toggle(klevuselectors.DROPDOWN_EXPAND_CLASS)
    })
  }

  handleClickOutside () {
    document.body.addEventListener('click', (e) => {
      if (!this.selectHeaderEl.contains(e.target) && !this.optionEl.contains(e.target)) {
        this.selectEl.classList.remove(klevuselectors.DROPDOWN_EXPAND_CLASS)
      }
    })
  }
}

if (!customElements.get('klevu-sort')) {
  customElements.define('klevu-sort', KlevuSort)
}

class KlevuFiltersMobile extends HTMLElement {
  constructor () {
    super()
    this.mediaQueryList = {
        mobile: window.matchMedia('(max-width: 767px)'),
        tabletAndUp: window.matchMedia('(min-width: 768px)')
    };
    this.klevuHeader = this.closest('.klevuMeta__header')
    this.butonOpen = this.querySelector(klevuselectors.buttonOpen)
    this.slideout = this.querySelector(klevuselectors.slideout)
  }

  connectedCallback() {
    const self = this;
    this.setPosition();
    window.addEventListener("resize", function() {
        self.setPosition();
    });
    this.butonOpen?.addEventListener('click', () => {
      this.slideout && this.slideout.show()
      window.bodyScrollLock.disableBodyScroll('')
    })
  }
    
    setPosition() {
        if (this.mediaQueryList.mobile.matches && this.klevuHeader) {
            const siteHeader = document.querySelector('[data-section-id="header"]');
            this.klevuHeader.style.top = `${siteHeader.offsetHeight}px`
        }
    }
}

if (!customElements.get('klevu-filters-mobile')) {
  customElements.define('klevu-filters-mobile', KlevuFiltersMobile)
}

klevu.coreEvent.build({
  name: 'setRemoteConfigQuickOverride',
  fire: function () {
    if (
      klevu.getSetting(
        klevu,
        'settings.flags.setRemoteConfigQuick.build',
        false
      )
    ) {
      return true
    }
    return false
  },
  maxCount: 150,
  delay: 100
})

klevu.coreEvent.attach('setRemoteConfigQuickOverride', {
  name: 'attachRemoteConfigQuickOverride',
  fire: function () {
    klevu.each(klevu.search.extraSearchBox, function (key, box) {
      box.getScope().chains.template.events.add({
        name: 'anyUniqueName_1',
        fire: function (data, scope) {
          const targetNodeSearch = document.querySelector('.kuQuickSearchResultsContainer')

          const callback = function(mutationsList, observer) {
            for (const mutation of mutationsList) {
              if (mutation.attributeName && mutation.target.style.display === 'none') {
                window.bodyScrollLock.clearAllBodyScrollLocks()
                document.querySelector('.overlay').classList.remove('overlay--active')
              } else if (mutation.target.style.display === 'block') {
                window.bodyScrollLock.disableBodyScroll(document.querySelector('.kuQuickSearchResultsContainer .klevuWrap'))

                let topAnnoucment = document.querySelector(".top-announcement");
                let klevuWrap = document.querySelector(".kuQuickSearchResultsContainer .klevuWrap");

                if(topAnnoucment) {
                  if (topAnnoucment.classList.contains("d-none")) {
                    klevuWrap.classList.add('klevuWrap--active');
                  }
                  document.querySelector('.overlay').classList.add('overlay--active');
                }
              }
            }
          }

          const observer = new MutationObserver(callback)
          observer.observe(targetNodeSearch, { attributes: true })
        }
      })
    })

    klevu({
      powerUp: {
        quick: true
      }
    })
  }
})


// Apply the facets supplied in the current URL string
klevu.modifyRequest("landing, catnav", function (data, scope) {
    // klevu.each(data.request.current.recordQueries, function (key, query) {
    //   query.filters.filtersToReturn.options.limit = 30; //   UNCOMMENT, if you want to change default number of facet items
    //   query.settings.limit = 48; // UNCOMMENT, if you want to change default number of products
    // });
    
    function smoothScrollToTop() {
        setTimeout(function () {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }, 100);
    }
    
    let filterLinks = document.querySelectorAll('.kuFilterBox .kuFilterNames ul li a');
    filterLinks.forEach(function (elem) {
        elem.addEventListener('click', function (event) {
            smoothScrollToTop();
        });
    });
    
    let paginationLinks = document.querySelectorAll('.kuPagination a');
    paginationLinks.forEach(function (elem) {
        elem.addEventListener('click', function (event) {
            smoothScrollToTop();
        });
    });
    
    // Restore Search Params On Page Load
    klevu.search.modules.addParamsToURL.base.restoreSearchParamsOnPageLoad(
        data,
        scope
    );
    
    // set the global scope
    window.klevuCurrentScope = scope.kScope;
    window.klevuProductBlockIteration = 0;
});

klevu.beforeActivation("full_page", function (data, scope) {
    scope.kScope.chains.events.keyUp.remove({ name: "scrollToTop" });
});

klevu.afterTemplateRender("landing, catnav", function (data, scope) {
    const dummyProductsList = document.getElementById('od-dummy-products-list');
    if (dummyProductsList) {
        dummyProductsList.remove();
    }
    // Add selected FILTERS and PAGINATION to the URL
    klevu.search.modules.addParamsToURL.base.addURLtoHistory(data, scope);
    
    const kuDropItemsPerpage = document.getElementById('kuDropItemsPerpage');
    const kuDropItemsPerpageHeader = document.getElementById('kuDropItemsPerpageHeader');
    
    function handleOutsideClick(event) {
        if (!kuDropItemsPerpage.contains(event.target)) {
            kuDropItemsPerpage.classList.remove('is-expand');
            document.removeEventListener('click', handleOutsideClick);
        }
    }
    
    kuDropItemsPerpageHeader.addEventListener('click', (event) => {
        event.stopPropagation();
        kuDropItemsPerpage.classList.toggle('is-expand');
        
        if (kuDropItemsPerpage.classList.contains('is-expand')) {
            document.addEventListener('click', handleOutsideClick);
        } else {
            document.removeEventListener('click', handleOutsideClick);
        }
    });
});

window.onpopstate = function (event) {
    try {
        // passing activeQueryId because it's lost once we reset the data below
        var activeQueryId = klevu.getObjectPath(
            window.klevuCurrentScope.element.kObject.getScope().data,
            "context.activeQueryId"
        );
        // code to get ready to reset all the data
        var data = window.klevuCurrentScope.element.kObject.getScope().data;
        var scope = window.klevuCurrentScope.element;
        scope.kScope.data = scope.kObject.resetData(scope.kElem);
        scope.kScope.data.context.keyCode = 0;
        scope.kScope.data.context.eventObject = event;
        scope.kScope.data.context.event = "keyUp";
        scope.kScope.data.context.preventDefault = false;
        
        // Get payload for Filters & Pagination
        klevu.search.modules.addParamsToURL.base.updatePayloadOnPopState(
            data,
            scope,
            activeQueryId
        );
        
        // Fire request, re-render results
        klevu.event.fireChain(
            scope.kScope,
            "chains.events.keyUp",
            scope,
            scope.kScope.data,
            event
        );
    } catch (error) {
        console.log(error);
    }
};

// filters & pagination to URL
(function (klevu) {
    klevu.extend(true, klevu.search.modules, {
        addParamsToURL: {
            base: {
                addURLtoHistory: function (data, scope, queryId) {
                    // Global stuff
                    if (
                        typeof window.history === "undefined" ||
                        typeof window.history.pushState === "undefined"
                    ) {
                        console.error(
                            "This browser does not have the support of window.history or window.history.pushState"
                        );
                        return;
                    }
                    
                    var searchPath = new URLSearchParams(window.location.search);
                    var currentSearchPath;
                    var previousSearchPath = searchPath.toString();
                    
                    // this is in case we're running our code where we dont have context.activeQueryId
                    var activeQueryId = klevu.getObjectPath(
                        data,
                        "context.activeQueryId"
                    );
                    if (queryId && queryId.length) {
                        activeQueryId = queryId;
                    }
                    
                    // Check if there any filter selected
                    let applyFilters =
                        typeof data.localOverrides.query[activeQueryId].filters !==
                        "undefined"
                            ? data.localOverrides.query[activeQueryId].filters.applyFilters
                            : {};
                    let isThereFiltersSelected = false;
                    // Check if applyFilters is an object (but not an array), and not empty
                    if (
                        typeof applyFilters === "object" &&
                        !Array.isArray(applyFilters) &&
                        applyFilters !== null &&
                        Object.keys(applyFilters).length > 0
                    ) {
                        isThereFiltersSelected = true;
                    }
                    
                    // PAGINATION TO URL
                    var hasPaginationEnabled = klevu.getSetting(
                        klevu,
                        "settings.theme.modules.pagination.searchResultsPage.enable"
                    );
                    var paginationQueryParam = "Page";
                    var currentPage = 0;
                    
                    if (hasPaginationEnabled) {
                        var activeQueryMeta = klevu.getObjectPath(
                            data,
                            "template.query." + activeQueryId + ".meta"
                        );
                        if (activeQueryMeta) {
                            var productListLimit = activeQueryMeta.noOfResults;
                            currentPage =
                                Math.ceil(activeQueryMeta.offset / productListLimit) + 1;
                        }
                        
                        if (currentPage === 0 || currentPage === 1) {
                            searchPath.delete(paginationQueryParam);
                        } else {
                            searchPath.set(paginationQueryParam, currentPage);
                        }
                        
                        currentSearchPath = searchPath.toString();
                    }
                    
                    // FILTERS TO URL
                    var activeQueryFilters = klevu.getObjectPath(
                        data,
                        "template.query." + activeQueryId + ".filters"
                    );
                    var filterValuesQueryParam = "";
                    
                    if (activeQueryFilters) {
                        klevu.each(activeQueryFilters, function (key, filter) {
                            var selectedFilterKeyString = "";
                            var filterOptions = filter.options;
                            var selectedValues = "";
                            
                            if (filterOptions && filterOptions.length) {
                                klevu.each(filterOptions, function (key, option) {
                                    if (option.selected === true) {
                                        if (selectedValues.length) {
                                            selectedValues += ",";
                                        }
                                        selectedValues += option.value;
                                    }
                                });
                            } else if (filter.type === "SLIDER") {
                                var startValue = filter.start;
                                var endValue = filter.end;
                                var minValue = filter.min;
                                var maxValue = filter.max;
                                if (
                                    typeof startValue !== "undefined" &&
                                    startValue !== null &&
                                    typeof endValue !== "undefined" &&
                                    endValue !== null
                                ) {
                                    if (
                                        Number(startValue) === Number(minValue) &&
                                        Number(endValue) === Number(maxValue)
                                    ) {
                                        // just skipping
                                    } else {
                                        selectedValues = startValue + "-" + endValue;
                                    }
                                }
                            }
                            
                            if (selectedValues.length) {
                                // selectedFilterKeyString += filter.key + ":" + selectedValues;
                                selectedFilterKeyString +=
                                    encodeURIComponent(filter.key) +
                                    ":" +
                                    encodeURIComponent(selectedValues);
                            }
                            
                            if (selectedFilterKeyString.length) {
                                if (filterValuesQueryParam.length) {
                                    filterValuesQueryParam += ";";
                                }
                                filterValuesQueryParam += selectedFilterKeyString;
                            }
                        });
                    }
                    
                    if (filterValuesQueryParam.length > 0 && isThereFiltersSelected) {
                        searchPath.set("Filters", filterValuesQueryParam);
                    } else {
                        searchPath.delete("Filters");
                    }
                    
                    currentSearchPath = searchPath.toString();
                    
                    // ==============================
                    // Final URL change
                    if (previousSearchPath !== currentSearchPath) {
                        var historyState = {
                            page: currentPage,
                            filters: currentSearchPath,
                        };
                        window.history.pushState(
                            historyState,
                            null,
                            currentSearchPath
                                ? "?" + currentSearchPath
                                : window.location.pathname
                        );
                    }
                },
                
                restoreSearchParamsOnPageLoad: function (data, scope) {
                    var hasAlreadyTriggered = klevu.getObjectPath(
                        scope.kScope,
                        "element.kScope.getAndUpdateFiltersTriggered"
                    );
                    if (hasAlreadyTriggered) return;
                    
                    // var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");
                    var activeQueryId = "productList";
                    var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                    var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");
                    
                    var matchedQueryParamId = "";
                    var matchedQueryParamValue = "";
                    var recordQueries = klevu.getObjectPath(
                        data,
                        "request.current.recordQueries"
                    );
                    
                    if (recordQueries && recordQueries.length) {
                        klevu.each(recordQueries, function (key, recordQuery) {
                            if (recordQuery.id) {
                                if (
                                    (paginationFromURL && paginationFromURL.length) ||
                                    (filtersFromURL && filtersFromURL.length)
                                ) {
                                    matchedQueryParamId = recordQuery.id;
                                    matchedQueryParamValue = paginationFromURL || filtersFromURL;
                                }
                            }
                        });
                    }
                    
                    klevu.setObjectPath(
                        scope.kScope,
                        "element.kScope.getAndUpdateFiltersTriggered",
                        true
                    );
                    
                    matchedQueryParamId = "productList";
                    
                    if (matchedQueryParamId.length && matchedQueryParamValue.length) {
                        activeQueryId = matchedQueryParamId;
                        var storage = klevu.getSetting(
                            scope.kScope.settings,
                            "settings.storage"
                        );
                        if (storage.tabs) {
                            storage.tabs.setStorage("local");
                            storage.tabs.mergeFromGlobal();
                            storage.tabs.addElement("active", activeQueryId);
                            storage.tabs.mergeToGlobal();
                        }
                    }
                    
                    if (paginationFromURL && paginationFromURL > 1) {
                        if (recordQueries && recordQueries.length) {
                            klevu.each(recordQueries, function (key, recordQuery) {
                                if (recordQuery.id === activeQueryId) {
                                    var limit = klevu.getObjectPath(
                                        recordQuery,
                                        "settings.limit"
                                    );
                                    limit = Number(limit);
                                    if (limit > 0) {
                                        var expectedOffset = (paginationFromURL - 1) * limit;
                                        klevu.setObjectPath(
                                            data,
                                            "localOverrides.query." +
                                            activeQueryId +
                                            ".settings.offset",
                                            expectedOffset
                                        );
                                    }
                                }
                            });
                        }
                    }
                    
                    // FILTERS
                    if (filtersFromURL && filtersFromURL.length) {
                        var facets = filtersFromURL.split(";");
                        if (facets) {
                            klevu.each(facets, function (key, facet) {
                                var splitFacet = facet.split(":");
                                if (splitFacet.length) {
                                    var facetKey = decodeURIComponent(splitFacet[0]);
                                    var facetValues = decodeURIComponent(splitFacet[1]).split(
                                        ","
                                    );
                                    var applyFilters = klevu.getObjectPath(
                                        data,
                                        "localOverrides.query." +
                                        activeQueryId +
                                        ".filters.applyFilters.filters"
                                    );
                                    
                                    if (applyFilters && applyFilters.length) {
                                        // if there're some filters
                                        var isExistingKey = false;
                                        klevu.each(applyFilters, function (key, applyFilter) {
                                            if (applyFilter.key === facetKey) {
                                                isExistingKey = true;
                                                klevu.each(facetValues, function (key, facetValue) {
                                                    var isFilterOptionMatched = false;
                                                    klevu.each(applyFilter.values, function (key, value) {
                                                        if (facetValue === value) {
                                                            isFilterOptionMatched = true;
                                                        }
                                                    });
                                                    if (!isFilterOptionMatched) {
                                                        applyFilter.values.push(facetValue);
                                                    }
                                                });
                                            }
                                        });
                                        if (!isExistingKey) {
                                            applyFilters.push({ key: facetKey, values: facetValues });
                                        }
                                    } else {
                                        klevu.setObjectPath(
                                            data,
                                            "localOverrides.query." +
                                            activeQueryId +
                                            ".filters.applyFilters.filters",
                                            [{ key: facetKey, values: facetValues }]
                                        );
                                    }
                                }
                            });
                        }
                    }
                },
                
                updatePayloadOnPopState: function (data, scope, activeQueryId) {
                    // SET PAGINATION PAYLOAD
                    var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");
                    paginationFromURL = Number(paginationFromURL);
                    var limit =
                        window.klevuCurrentScope.element.kObject.getScope().data.request
                            .original.queryRequest[0].settings.limit;
                    limit = Number(limit);
                    if (limit > 0) {
                        var expectedOffset =
                            (paginationFromURL - 1) * limit > 0
                                ? (paginationFromURL - 1) * limit
                                : 0;
                        klevu.setObjectPath(
                            data,
                            "localOverrides.query." + activeQueryId + ".settings.offset",
                            expectedOffset
                        );
                        // klevu.search.modules.addParamsToURL.base.backBtnCounter.backBtn = 0;
                    }
                    
                    // SET FILTER PAYLOAD
                    var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                    if (filtersFromURL && filtersFromURL.length) {
                        var facets = filtersFromURL.split(";");
                        // loop through all facets to get its values
                        let facetKey = "";
                        let facetValues = [];
                        let facetsArray = [];
                        
                        klevu.each(facets, function (key, facet) {
                            var splitFacet = facet.split(":");
                            if (splitFacet.length) {
                                facetKey = decodeURIComponent(splitFacet[0]);
                                facetValues = decodeURIComponent(splitFacet[1]).split(",");
                                facetsArray.push({ key: facetKey, values: facetValues });
                            }
                        });
                        // set the payload with correct filters:
                        klevu.setObjectPath(
                            data,
                            "localOverrides.query." +
                            activeQueryId +
                            ".filters.applyFilters.filters",
                            facetsArray
                        );
                    } else {
                        // reset filters if Back button pressed, and there's no filters
                        klevu.setObjectPath(
                            data,
                            "localOverrides.query." +
                            activeQueryId +
                            ".filters.applyFilters.filters",
                            []
                        );
                    }
                },
            },
            build: true,
        },
    });
})(klevu);

